import React from "react";
import classNames from "classnames";

type Props = {
  children?: string | number | JSX.Element | JSX.Element[];
  className?: string;
  value: string | number;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
};

const Option = ({ children, className, value, ...others }: Props) => {
  const classes = classNames(className);

  return (
    <option className={classes} value={value} {...others}>
      {children}
    </option>
  );
};

export default Option;
